import { useEffect, useState } from "react";
import useWilmaCustomers from "../../../data/useWilmaCustomers";
import { ICustomerName } from "../../../models/ICustomer";
import SelectInput from "../../shared/Inputs/SelectInput";
import { useForm } from "react-hook-form";
import { wilmaSAVCustomerId } from "../../../config";
import { useAuth } from "../../../contexts/AuthContext";

export default function CustomerSelect({ onChange }: { onChange: (customerId: string | null) => void }) {
  const { watch, register, setValue } = useForm();
  const { customers } = useWilmaCustomers();
  const { loading, customerId } = useAuth();
  const [options, setOptions] = useState<{ name: string; id: string }[]>([]);
  const [customer, setCustomer] = useState<ICustomerName | null>(null);

  const selectedCustomerId = watch("customerId");

  useEffect(() => {
    if (!customers.isLoading && customers.data) {
      const foundCustomer = customers.data.data.find(c => c.id === customerId);
      setCustomer(foundCustomer || null);
      setOptions(customers.data.data.map(c => ({ name: c.name, id: c.id })));
      setValue("customerId", foundCustomer?.id || null);
    }
  }, [customers.data, customers.isLoading, customerId]);

  useEffect(() => {
    onChange(selectedCustomerId || null);
  }, [selectedCustomerId]);

  if (customerId !== wilmaSAVCustomerId) return null;

  return (
    <SelectInput
      label={null}
      register={register}
      registerName={"customerId"}
      options={options}
      setValue={setValue}
      watch={watch}
      cols="w-full sm:w-auto sm:min-w-64"
    />
  );
}